<template>
  <div class="not-found">
    <h1>404</h1>
    <p>Page not found</p>
    <el-button type="primary" @click="$router.push('/')">Back to Home</el-button>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  color: #333;
}
.not-found h1 {
  font-size: 80px;
  margin: 0;
  color: #409EFF;
}
.not-found p {
  font-size: 20px;
  margin: 16px 0 32px;
}
</style>



// WEBPACK FOOTER //
// src/views/NotFound.vue